// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../font/budicons/snugg-6.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../font/budicons/snugg-6.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../font/budicons/snugg-6.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../font/budicons/snugg-6.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#snugg-6" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =================================================================================  */
/* ======  Start custom Snugg Code - Do not overwrite with default budicon code ====  */

@charset "UTF-8";


/* Font paths are set in server/express-init.js. This is not the true relative path. */
@font-face {
  font-family: "snugg-6";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("svg");
  font-weight: normal;
  font-style: normal;

}

.btn [class^="ico-"].ico-spin,
.nav [class^="ico-"].ico-spin,
.btn [class*=" ico-"].ico-spin,
.nav [class*=" ico-"].ico-spin {
  display: inline-block;
}

.btn [class^="ico-"].ico-spin.ico-large,
.btn [class*=" ico-"].ico-spin.ico-large {
  line-height: .8em;
}

/* Animated rotating icon */
.ico-spin {
  -webkit-transform-origin: 50% 47.5%;
  transform-origin: 50% 47.5%;
  -ms-transform-origin: 50% 47.5%;
  /* IE 9 */
  line-height: 0.4em !important;
  display: inline-block;
  -moz-animation: spin 2s infinite linear;
  -o-animation: spin 2s infinite linear;
  -webkit-animation: spin 2s infinite linear;
  animation: spin 2s infinite linear;
}

/* Prevent stack and spinners from being taken inline when inside a link */
a .ico-stack,
a .ico-spin {
  display: inline-block;
  text-decoration: none;
}

@-moz-keyframes spin {
  0% {
    -moz-transform: rotate(0deg);
  }

  100% {
    -moz-transform: rotate(359deg);
  }
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(359deg);
  }
}

@-o-keyframes spin {
  0% {
    -o-transform: rotate(0deg);
  }

  100% {
    -o-transform: rotate(359deg);
  }
}

@-ms-keyframes spin {
  0% {
    -ms-transform: rotate(0deg);
  }

  100% {
    -ms-transform: rotate(359deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(359deg);
  }
}

/* Icon rotations and mirroring */
.ico-rotate-90:before {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
}

.ico-rotate-180:before {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
}

.ico-rotate-270:before {
  -webkit-transform: rotate(270deg);
  -moz-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  -o-transform: rotate(270deg);
  transform: rotate(270deg);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
}

.ico-flip-horizontal:before {
  -webkit-transform: scale(-1, 1);
  -moz-transform: scale(-1, 1);
  -ms-transform: scale(-1, 1);
  -o-transform: scale(-1, 1);
  transform: scale(-1, 1);
}

.ico-flip-vertical:before {
  -webkit-transform: scale(1, -1);
  -moz-transform: scale(1, -1);
  -ms-transform: scale(1, -1);
  -o-transform: scale(1, -1);
  transform: scale(1, -1);
}

/* ensure rotation occurs inside anchor tags */
a .ico-rotate-90:before,
a .ico-rotate-180:before,
a .ico-rotate-270:before,
a .ico-flip-horizontal:before,
a .ico-flip-vertical:before {
  display: inline-block;
}

[data-icon]:before {
  content: attr(data-icon);
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  visibility: hidden;

}

[class^="ico-"]:before,
[class*=" ico-"]:before {
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  visibility: hidden;
}

[data-icon]:before {
  font-family: "snugg-6" !important;
  visibility: visible;
}

[class^="ico-"]:before,
[class*=" ico-"]:before {
  font-family: "snugg-6" !important;
  visibility: visible;

}




/* ======  End custom Snugg Code - Do not overwrite above this line with default budicon code ====  */
/* ===============================================================================================  */

.ico-budicon:before {
  content: "\\61";
}

.ico-budicon-1:before {
  content: "\\62";
}

.ico-budicon-2:before {
  content: "\\63";
}

.ico-budicon-3:before {
  content: "\\64";
}

.ico-budicon-4:before {
  content: "\\65";
}

.ico-budicon-5:before {
  content: "\\66";
}

.ico-budicon-6:before {
  content: "\\67";
}

.ico-budicon-8:before {
  content: "\\69";
}

.ico-budicon-9:before {
  content: "\\6a";
}

.ico-budicon-10:before {
  content: "\\6b";
}

.ico-budicon-11:before {
  content: "\\6c";
}

.ico-budicon-12:before {
  content: "\\6d";
}

.ico-budicon-13:before {
  content: "\\6e";
}

.ico-budicon-14:before {
  content: "\\6f";
}

.ico-budicon-16:before {
  content: "\\71";
}

.ico-budicon-17:before {
  content: "\\72";
}

.ico-budicon-18:before {
  content: "\\73";
}

.ico-budicon-19:before {
  content: "\\74";
}

.ico-budicon-20:before {
  content: "\\75";
}

.ico-budicon-21:before {
  content: "\\76";
}

.ico-budicon-22:before {
  content: "\\77";
}

.ico-budicon-23:before {
  content: "\\78";
}

.ico-budicon-24:before {
  content: "\\79";
}

.ico-budicon-25:before {
  content: "\\7a";
}

.ico-budicon-26:before {
  content: "\\41";
}

.ico-budicon-27:before {
  content: "\\42";
}

.ico-budicon-28:before {
  content: "\\43";
}

.ico-budicon-29:before {
  content: "\\44";
}

.ico-budicon-30:before {
  content: "\\45";
}

.ico-budicon-31:before {
  content: "\\46";
}

.ico-budicon-32:before {
  content: "\\47";
}

.ico-budicon-33:before {
  content: "\\48";
}

.ico-budicon-34:before {
  content: "\\49";
}

.ico-budicon-35:before {
  content: "\\4a";
}

.ico-budicon-36:before {
  content: "\\4b";
}

.ico-budicon-37:before {
  content: "\\4c";
}

.ico-budicon-38:before {
  content: "\\4d";
}

.ico-budicon-39:before {
  content: "\\4e";
}

.ico-budicon-40:before {
  content: "\\4f";
}

.ico-budicon-41:before {
  content: "\\50";
}

.ico-budicon-42:before {
  content: "\\51";
}

.ico-budicon-43:before {
  content: "\\52";
}

.ico-budicon-44:before {
  content: "\\53";
}

.ico-budicon-45:before {
  content: "\\54";
}

.ico-budicon-47:before {
  content: "\\56";
}

.ico-budicon-49:before {
  content: "\\58";
}

.ico-budicon-46:before {
  content: "\\55";
}

.ico-budicon-48:before {
  content: "\\57";
}

.ico-budicon-15:before {
  content: "\\70";
}

.ico-budicon-50:before {
  content: "\\59";
}

.ico-budicon-52:before {
  content: "\\30";
}

.ico-budicon-51:before {
  content: "\\5a";
}

.ico-budicon-53:before {
  content: "\\31";
}

.ico-budicon-54:before {
  content: "\\32";
}

.ico-budicon-56:before {
  content: "\\34";
}

.ico-budicon-55:before {
  content: "\\33";
}

.ico-budicon-57:before {
  content: "\\35";
}

.ico-budicon-58:before {
  content: "\\36";
}

.ico-budicon-59:before {
  content: "\\37";
}

.ico-budicon-60:before {
  content: "\\38";
}

.ico-budicon-61:before {
  content: "\\39";
}

.ico-budicon-62:before {
  content: "\\21";
}

.ico-budicon-63:before {
  content: "\\22";
}

.ico-budicon-64:before {
  content: "\\23";
}

.ico-budicon-65:before {
  content: "\\24";
}

.ico-budicon-66:before {
  content: "\\25";
}

.ico-budicon-67:before {
  content: "\\26";
}

.ico-budicon-68:before {
  content: "\\27";
}

.ico-budicon-69:before {
  content: "\\28";
}

.ico-budicon-70:before {
  content: "\\29";
}

.ico-list-number:before {
  content: "\\2a";
}

.ico-list-bullet:before {
  content: "\\2b";
}

.ico-budicon-71:before {
  content: "\\2c";
}

.ico-budicon-72:before {
  content: "\\2d";
}

.ico-budicon-73:before {
  content: "\\2e";
}

.ico-budicon-74:before {
  content: "\\2f";
}

.ico-budicon-75:before {
  content: "\\3a";
}

.ico-budicon-76:before {
  content: "\\3b";
}

.ico-budicon-77:before {
  content: "\\3c";
}

.ico-budicon-78:before {
  content: "\\3d";
}

.ico-budicon-79:before {
  content: "\\3e";
}

.ico-budicon-80:before {
  content: "\\3f";
}

.ico-budicon-81:before {
  content: "\\40";
}

.ico-ios-snowy:before {
  content: "\\5b";
}

.ico-budicon-82:before {
  content: "\\5d";
}

.ico-budicon-83:before {
  content: "\\5e";
}

.ico-load-d:before {
  content: "\\5f";
}

.ico-budicon-84:before {
  content: "\\60";
}

.ico-budicon-85:before {
  content: "\\7b";
}

.ico-budicon-86:before {
  content: "\\7c";
}

.ico-budicon-87:before {
  content: "\\7d";
}

.ico-budicon-88:before {
  content: "\\7e";
}

.ico-budicon-89:before {
  content: "\\5c";
}

.ico-budicon-90:before {
  content: "\\e000";
}

.ico-budicon-91:before {
  content: "\\e001";
}

.ico-budicon-92:before {
  content: "\\e002";
}

.ico-budicon-93:before {
  content: "\\e003";
}

.ico-budicon-7:before {
  content: "\\68";
}

.ico-budicon-94:before {
  content: "\\e004";
}

.ico-budicon-95:before {
  content: "\\e005";
}

.ico-budicon-96:before {
  content: "\\e006";
}

.ico-budicon-97:before {
  content: "\\e007";
}

.ico-budicon-98:before {
  content: "\\e008";
}

.ico-budicon-99:before {
  content: "\\e009";
}

.ico-budicon-100:before {
  content: "\\e00a";
}

.ico-budicon-102:before {
  content: "\\e00c";
}
`, "",{"version":3,"sources":["webpack://./src/css/budicons.css"],"names":[],"mappings":"AAAA,uFAAuF;AACvF,uFAAuF;;AAEvF,gBAAgB;;;AAGhB,sFAAsF;AACtF;EACE,sBAAsB;EACtB,4CAAwC;EACxC;;;yDAG2D;EAC3D,mBAAmB;EACnB,kBAAkB;;AAEpB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,+BAA+B;EAC/B,SAAS;EACT,6BAA6B;EAC7B,qBAAqB;EACrB,uCAAuC;EACvC,qCAAqC;EACrC,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA,0EAA0E;AAC1E;;EAEE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,iCAAiC;AACjC;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,gEAAgE;AAClE;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;EACzB,gEAAgE;AAClE;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;EACzB,gEAAgE;AAClE;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,8CAA8C;AAC9C;;;;;EAKE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,WAAW;EACX,cAAc;EACd,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;;AAEpB;;AAEA;;EAEE,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,WAAW;EACX,cAAc;EACd,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;;EAEE,iCAAiC;EACjC,mBAAmB;;AAErB;;;;;AAKA,qGAAqG;AACrG,qGAAqG;;AAErG;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* =================================================================================  */\n/* ======  Start custom Snugg Code - Do not overwrite with default budicon code ====  */\n\n@charset \"UTF-8\";\n\n\n/* Font paths are set in server/express-init.js. This is not the true relative path. */\n@font-face {\n  font-family: \"snugg-6\";\n  src: url(\"../font/budicons/snugg-6.eot\");\n  src: url(\"../font/budicons/snugg-6.eot?#iefix\") format(\"embedded-opentype\"),\n    url(\"../font/budicons/snugg-6.woff\") format(\"woff\"),\n    url(\"../font/budicons/snugg-6.ttf\") format(\"truetype\"),\n    url(\"../font/budicons/snugg-6.svg#snugg-6\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n\n}\n\n.btn [class^=\"ico-\"].ico-spin,\n.nav [class^=\"ico-\"].ico-spin,\n.btn [class*=\" ico-\"].ico-spin,\n.nav [class*=\" ico-\"].ico-spin {\n  display: inline-block;\n}\n\n.btn [class^=\"ico-\"].ico-spin.ico-large,\n.btn [class*=\" ico-\"].ico-spin.ico-large {\n  line-height: .8em;\n}\n\n/* Animated rotating icon */\n.ico-spin {\n  -webkit-transform-origin: 50% 47.5%;\n  transform-origin: 50% 47.5%;\n  -ms-transform-origin: 50% 47.5%;\n  /* IE 9 */\n  line-height: 0.4em !important;\n  display: inline-block;\n  -moz-animation: spin 2s infinite linear;\n  -o-animation: spin 2s infinite linear;\n  -webkit-animation: spin 2s infinite linear;\n  animation: spin 2s infinite linear;\n}\n\n/* Prevent stack and spinners from being taken inline when inside a link */\na .ico-stack,\na .ico-spin {\n  display: inline-block;\n  text-decoration: none;\n}\n\n@-moz-keyframes spin {\n  0% {\n    -moz-transform: rotate(0deg);\n  }\n\n  100% {\n    -moz-transform: rotate(359deg);\n  }\n}\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n\n  100% {\n    -webkit-transform: rotate(359deg);\n  }\n}\n\n@-o-keyframes spin {\n  0% {\n    -o-transform: rotate(0deg);\n  }\n\n  100% {\n    -o-transform: rotate(359deg);\n  }\n}\n\n@-ms-keyframes spin {\n  0% {\n    -ms-transform: rotate(0deg);\n  }\n\n  100% {\n    -ms-transform: rotate(359deg);\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(359deg);\n  }\n}\n\n/* Icon rotations and mirroring */\n.ico-rotate-90:before {\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n}\n\n.ico-rotate-180:before {\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg);\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n}\n\n.ico-rotate-270:before {\n  -webkit-transform: rotate(270deg);\n  -moz-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  -o-transform: rotate(270deg);\n  transform: rotate(270deg);\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n}\n\n.ico-flip-horizontal:before {\n  -webkit-transform: scale(-1, 1);\n  -moz-transform: scale(-1, 1);\n  -ms-transform: scale(-1, 1);\n  -o-transform: scale(-1, 1);\n  transform: scale(-1, 1);\n}\n\n.ico-flip-vertical:before {\n  -webkit-transform: scale(1, -1);\n  -moz-transform: scale(1, -1);\n  -ms-transform: scale(1, -1);\n  -o-transform: scale(1, -1);\n  transform: scale(1, -1);\n}\n\n/* ensure rotation occurs inside anchor tags */\na .ico-rotate-90:before,\na .ico-rotate-180:before,\na .ico-rotate-270:before,\na .ico-flip-horizontal:before,\na .ico-flip-vertical:before {\n  display: inline-block;\n}\n\n[data-icon]:before {\n  content: attr(data-icon);\n  font-style: normal !important;\n  font-weight: normal !important;\n  font-variant: normal !important;\n  text-transform: none !important;\n  speak: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  visibility: hidden;\n\n}\n\n[class^=\"ico-\"]:before,\n[class*=\" ico-\"]:before {\n  font-style: normal !important;\n  font-weight: normal !important;\n  font-variant: normal !important;\n  text-transform: none !important;\n  speak: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  visibility: hidden;\n}\n\n[data-icon]:before {\n  font-family: \"snugg-6\" !important;\n  visibility: visible;\n}\n\n[class^=\"ico-\"]:before,\n[class*=\" ico-\"]:before {\n  font-family: \"snugg-6\" !important;\n  visibility: visible;\n\n}\n\n\n\n\n/* ======  End custom Snugg Code - Do not overwrite above this line with default budicon code ====  */\n/* ===============================================================================================  */\n\n.ico-budicon:before {\n  content: \"\\61\";\n}\n\n.ico-budicon-1:before {\n  content: \"\\62\";\n}\n\n.ico-budicon-2:before {\n  content: \"\\63\";\n}\n\n.ico-budicon-3:before {\n  content: \"\\64\";\n}\n\n.ico-budicon-4:before {\n  content: \"\\65\";\n}\n\n.ico-budicon-5:before {\n  content: \"\\66\";\n}\n\n.ico-budicon-6:before {\n  content: \"\\67\";\n}\n\n.ico-budicon-8:before {\n  content: \"\\69\";\n}\n\n.ico-budicon-9:before {\n  content: \"\\6a\";\n}\n\n.ico-budicon-10:before {\n  content: \"\\6b\";\n}\n\n.ico-budicon-11:before {\n  content: \"\\6c\";\n}\n\n.ico-budicon-12:before {\n  content: \"\\6d\";\n}\n\n.ico-budicon-13:before {\n  content: \"\\6e\";\n}\n\n.ico-budicon-14:before {\n  content: \"\\6f\";\n}\n\n.ico-budicon-16:before {\n  content: \"\\71\";\n}\n\n.ico-budicon-17:before {\n  content: \"\\72\";\n}\n\n.ico-budicon-18:before {\n  content: \"\\73\";\n}\n\n.ico-budicon-19:before {\n  content: \"\\74\";\n}\n\n.ico-budicon-20:before {\n  content: \"\\75\";\n}\n\n.ico-budicon-21:before {\n  content: \"\\76\";\n}\n\n.ico-budicon-22:before {\n  content: \"\\77\";\n}\n\n.ico-budicon-23:before {\n  content: \"\\78\";\n}\n\n.ico-budicon-24:before {\n  content: \"\\79\";\n}\n\n.ico-budicon-25:before {\n  content: \"\\7a\";\n}\n\n.ico-budicon-26:before {\n  content: \"\\41\";\n}\n\n.ico-budicon-27:before {\n  content: \"\\42\";\n}\n\n.ico-budicon-28:before {\n  content: \"\\43\";\n}\n\n.ico-budicon-29:before {\n  content: \"\\44\";\n}\n\n.ico-budicon-30:before {\n  content: \"\\45\";\n}\n\n.ico-budicon-31:before {\n  content: \"\\46\";\n}\n\n.ico-budicon-32:before {\n  content: \"\\47\";\n}\n\n.ico-budicon-33:before {\n  content: \"\\48\";\n}\n\n.ico-budicon-34:before {\n  content: \"\\49\";\n}\n\n.ico-budicon-35:before {\n  content: \"\\4a\";\n}\n\n.ico-budicon-36:before {\n  content: \"\\4b\";\n}\n\n.ico-budicon-37:before {\n  content: \"\\4c\";\n}\n\n.ico-budicon-38:before {\n  content: \"\\4d\";\n}\n\n.ico-budicon-39:before {\n  content: \"\\4e\";\n}\n\n.ico-budicon-40:before {\n  content: \"\\4f\";\n}\n\n.ico-budicon-41:before {\n  content: \"\\50\";\n}\n\n.ico-budicon-42:before {\n  content: \"\\51\";\n}\n\n.ico-budicon-43:before {\n  content: \"\\52\";\n}\n\n.ico-budicon-44:before {\n  content: \"\\53\";\n}\n\n.ico-budicon-45:before {\n  content: \"\\54\";\n}\n\n.ico-budicon-47:before {\n  content: \"\\56\";\n}\n\n.ico-budicon-49:before {\n  content: \"\\58\";\n}\n\n.ico-budicon-46:before {\n  content: \"\\55\";\n}\n\n.ico-budicon-48:before {\n  content: \"\\57\";\n}\n\n.ico-budicon-15:before {\n  content: \"\\70\";\n}\n\n.ico-budicon-50:before {\n  content: \"\\59\";\n}\n\n.ico-budicon-52:before {\n  content: \"\\30\";\n}\n\n.ico-budicon-51:before {\n  content: \"\\5a\";\n}\n\n.ico-budicon-53:before {\n  content: \"\\31\";\n}\n\n.ico-budicon-54:before {\n  content: \"\\32\";\n}\n\n.ico-budicon-56:before {\n  content: \"\\34\";\n}\n\n.ico-budicon-55:before {\n  content: \"\\33\";\n}\n\n.ico-budicon-57:before {\n  content: \"\\35\";\n}\n\n.ico-budicon-58:before {\n  content: \"\\36\";\n}\n\n.ico-budicon-59:before {\n  content: \"\\37\";\n}\n\n.ico-budicon-60:before {\n  content: \"\\38\";\n}\n\n.ico-budicon-61:before {\n  content: \"\\39\";\n}\n\n.ico-budicon-62:before {\n  content: \"\\21\";\n}\n\n.ico-budicon-63:before {\n  content: \"\\22\";\n}\n\n.ico-budicon-64:before {\n  content: \"\\23\";\n}\n\n.ico-budicon-65:before {\n  content: \"\\24\";\n}\n\n.ico-budicon-66:before {\n  content: \"\\25\";\n}\n\n.ico-budicon-67:before {\n  content: \"\\26\";\n}\n\n.ico-budicon-68:before {\n  content: \"\\27\";\n}\n\n.ico-budicon-69:before {\n  content: \"\\28\";\n}\n\n.ico-budicon-70:before {\n  content: \"\\29\";\n}\n\n.ico-list-number:before {\n  content: \"\\2a\";\n}\n\n.ico-list-bullet:before {\n  content: \"\\2b\";\n}\n\n.ico-budicon-71:before {\n  content: \"\\2c\";\n}\n\n.ico-budicon-72:before {\n  content: \"\\2d\";\n}\n\n.ico-budicon-73:before {\n  content: \"\\2e\";\n}\n\n.ico-budicon-74:before {\n  content: \"\\2f\";\n}\n\n.ico-budicon-75:before {\n  content: \"\\3a\";\n}\n\n.ico-budicon-76:before {\n  content: \"\\3b\";\n}\n\n.ico-budicon-77:before {\n  content: \"\\3c\";\n}\n\n.ico-budicon-78:before {\n  content: \"\\3d\";\n}\n\n.ico-budicon-79:before {\n  content: \"\\3e\";\n}\n\n.ico-budicon-80:before {\n  content: \"\\3f\";\n}\n\n.ico-budicon-81:before {\n  content: \"\\40\";\n}\n\n.ico-ios-snowy:before {\n  content: \"\\5b\";\n}\n\n.ico-budicon-82:before {\n  content: \"\\5d\";\n}\n\n.ico-budicon-83:before {\n  content: \"\\5e\";\n}\n\n.ico-load-d:before {\n  content: \"\\5f\";\n}\n\n.ico-budicon-84:before {\n  content: \"\\60\";\n}\n\n.ico-budicon-85:before {\n  content: \"\\7b\";\n}\n\n.ico-budicon-86:before {\n  content: \"\\7c\";\n}\n\n.ico-budicon-87:before {\n  content: \"\\7d\";\n}\n\n.ico-budicon-88:before {\n  content: \"\\7e\";\n}\n\n.ico-budicon-89:before {\n  content: \"\\5c\";\n}\n\n.ico-budicon-90:before {\n  content: \"\\e000\";\n}\n\n.ico-budicon-91:before {\n  content: \"\\e001\";\n}\n\n.ico-budicon-92:before {\n  content: \"\\e002\";\n}\n\n.ico-budicon-93:before {\n  content: \"\\e003\";\n}\n\n.ico-budicon-7:before {\n  content: \"\\68\";\n}\n\n.ico-budicon-94:before {\n  content: \"\\e004\";\n}\n\n.ico-budicon-95:before {\n  content: \"\\e005\";\n}\n\n.ico-budicon-96:before {\n  content: \"\\e006\";\n}\n\n.ico-budicon-97:before {\n  content: \"\\e007\";\n}\n\n.ico-budicon-98:before {\n  content: \"\\e008\";\n}\n\n.ico-budicon-99:before {\n  content: \"\\e009\";\n}\n\n.ico-budicon-100:before {\n  content: \"\\e00a\";\n}\n\n.ico-budicon-102:before {\n  content: \"\\e00c\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
